// article-controls.js
import Component, { Topic } from 'component';
import { assert } from 'utils';

export const FOR_ATTR           = 'for';              // id della grid target
export const TAG_ATTR           = 'data-tag';
export const DATA_SOURCE_ATTR   = 'data-source';      // selettore script JSON da cui dedurre i tag (chiavi)
export const SHOW_SOURCE_UI_ATTR= 'data-show-source'; // "true" per mostrare input sorgente
export const SHOW_PAGE_UI_ATTR  = 'data-show-page';   // "true" per mostrare input pagina

customElements.define('x-article-grid-controls', class extends Component {
  #forId = '';
  #wrap;
  #tag = "";
  #tags = [];
  #sourceSel = null;
  #showSourceUI = false;  //for debug
  #showPageUI = false;  //for debug

  constructor() {
    super();
    this.$element.tabs = this.querySelectorAll(`[${TAG_ATTR}]`);
    
    const searchParams = new URLSearchParams(location.search)
    const uri_tag = searchParams.get("tag")
    this.#tag = uri_tag
      ? decodeURI(uri_tag)
      : (this.getAttribute(TAG_ATTR) || '').trim();

    this.#highlight(this.#tag);
    this.$element.tabs.forEach(tagBtn => {
      const tag = tagBtn.dataset.tag.trim()
      
      this.#tags.push(tag);

      tagBtn.addEventListener('click', () => {
        this.pub(Topic.BLOG_TAG_SET, { targetId: this.#forId, tag, page: 1 }, { global: true });
        this.#tag = tag
        this.#highlight(tag);
      });
    });
  }

  render() {
    this.#forId = (this.getAttribute(FOR_ATTR) || '').trim();
    assert(this.#forId, `[x-article-grid-controls] Missing '${FOR_ATTR}' attribute (target grid id)`);

    this.#sourceSel = this.getAttribute(DATA_SOURCE_ATTR) || null;
    this.#showSourceUI = (this.getAttribute(SHOW_SOURCE_UI_ATTR) || 'false') === 'true';
    this.#showPageUI = (this.getAttribute(SHOW_PAGE_UI_ATTR) || 'false') === 'true';

    if (!this.#wrap) {
      this.#wrap = document.createElement('div');
      this.#wrap.className = 'x-article-controls';
      this.appendChild(this.#wrap);
    }
    this.#draw();
  }

  attributeChangedCallback() {
    this.render();
  }

  #draw() {

    // Sorgente (opzionale)
    if (this.#showSourceUI) {
      const sourceWrap = document.createElement('div');
      sourceWrap.className = 'x-article-controls__source';
      const input = document.createElement('input');
      input.type = 'text';
      input.placeholder = 'CSS selector sorgente JSON (es. #articles-by-tag)';
      input.value = this.#sourceSel || '';
      const apply = document.createElement('button');
      apply.type = 'button'; apply.textContent = 'Cambia sorgente';
      this.on(apply, 'click', () => {
        const sel = input.value.trim();
        if (!sel) return;
        this.pub(Topic.BLOG_SOURCE_SET, { targetId: this.#forId, source: sel }, { global: true });
      });

      const refresh = document.createElement('button');
      refresh.type = 'button'; refresh.textContent = 'Refresh';
      this.on(refresh, 'click', () => {
        this.pub(Topic.BLOG_REFRESH, { targetId: this.#forId }, { global: true });
      });

      sourceWrap.appendChild(input);
      sourceWrap.appendChild(apply);
      sourceWrap.appendChild(refresh);
      this.#wrap.appendChild(sourceWrap);
    }

    // Jump pagina (opzionale)
    if (this.#showPageUI) {
      const jumpWrap = document.createElement('div');
      jumpWrap.className = 'x-article-controls__page';
      const input = document.createElement('input');
      input.type = 'number'; input.min = '1'; input.placeholder = 'Vai a pagina…';
      const go = document.createElement('button');
      go.type = 'button'; go.textContent = 'Vai';
      this.on(go, 'click', () => {
        const page = parseInt(input.value, 10);
        if (!Number.isFinite(page)) return;
        this.pub(Topic.BLOG_PAGE_SET, { targetId: this.#forId, page }, { global: true });
      });
      jumpWrap.appendChild(input);
      jumpWrap.appendChild(go);
      this.#wrap.appendChild(jumpWrap);
    }
  }

  #highlight(current) {
    this.$element.tabs.forEach((tag_btn, idx) => {
      tag_btn.classList.toggle('active', tag_btn.dataset.tag == current);
    });
  }
});
